module.exports = __webpack_public_path__ + "img/cancel-clock.52dbd79e.svg";